<!-- 每日一练、错题集锦 试题列表 -->
<template>
  <div v-if="item" :class="{ 'shiti-item': true, 'shiti-item-2': size == 2 }">
 
    <div class="shiti-header">
      <div class="num">{{ index ? index : item.topicIndex }}</div>
      <div class="name">[{{ QuestionEnum[Number(item.questionType)] }}]</div>
      <div class="tigan" v-html="item.questionTitle"></div>
      <img :src="item.questionImage" alt="" v-if="item.questionImage" />
      <audio :src="item.questionAudio" controls v-if="item.questionAudio"></audio>
      <video :src="item.questionVideo" controls v-if="item.questionVideo"></video>
    </div>
    <!-- 单选 -->
    <template v-if="item.questionType == 0">
      <div class="pannelBody">
        <div class="option-html" v-for="(option, option_idx) in item.questionOptionList" :key="option_idx">
          <span class="label">{{ String.fromCharCode(65 + option_idx) }}.&nbsp;&nbsp;</span>
          <div v-html="option"></div>
        </div>
        <div class="option">
          <el-radio-group v-model="item.userAnswer">
            <el-radio :label="String.fromCharCode(65 + opt_index)" border v-for="(opt, opt_index) of item.questionOptionList.length" :key="opt_index" :disabled="isSubmit">
              {{ String.fromCharCode(65 + opt_index) }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </template>
    <!-- 多选 -->
    <template v-if="item.questionType == 1">
      <div class="pannelBody">
        <div class="option-html" v-for="(option, option_idx) in item.questionOptionList" :key="option_idx">
          <span class="label">{{ String.fromCharCode(65 + option_idx) }}.&nbsp;&nbsp;</span>
          <div v-html="option"></div>
        </div>
        <div class="option">
          <el-checkbox-group v-model="item.userAnswer" v-if="item.questionOptionList.length > 0" :disabled="isSubmit">
            <el-checkbox border class="btn btn-default" v-for="(opt, opt_index) of item.questionOptionList.length" :label="String.fromCharCode(65 + opt_index)" :key="opt_index">
              {{ String.fromCharCode(65 + opt_index) }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </template>
    <!-- 判断题 -->
    <template v-if="item.questionType == 2">
      <div class="pannelBody">
        <div class="option">
          <label class="btn btn-default">
            <el-radio label="A" border v-model="item.userAnswer" :disabled="isSubmit">对</el-radio>
          </label>
          <label class="btn btn-default">
            <el-radio label="B" border v-model="item.userAnswer" :disabled="isSubmit">错</el-radio>
          </label>
        </div>
      </div>
    </template>
    <!-- 组合题 -->
    <template v-if="item.questionType == 5">
      <div v-for="(ite, idx) of item.subTopicList" :key="idx">
        <!-- 试题渲染 -->
        <question-view :is-submit="isSubmit" :item="ite" :index="idx + 1" :size="2"></question-view>
      </div>
    </template>
    <!-- 不定项选择题 -->
    <template v-if="item.questionType == 6">
      <div class="pannelBody">
        <div class="option-html" v-for="(option, option_idx) in item.questionOptionList" :key="option_idx">
          <span class="label">{{ String.fromCharCode(65 + option_idx) }}.&nbsp;&nbsp;</span>
          <div v-html="option"></div>
        </div>
        <div class="option">
          <el-checkbox-group v-model="item.userAnswer" v-if="item.questionOptionList && item.questionOptionList.length > 0" :disabled="isSubmit">
            <el-checkbox border class="btn btn-default" v-for="(opt, opt_index) of item.questionOptionList.length" :label="String.fromCharCode(65 + opt_index)" :key="opt_index">
              {{ String.fromCharCode(65 + opt_index) }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </template>

    <slot></slot>

    <!-- 解析 -->
    <div class="analysis-con" v-if="isSubmit && item.questionType != 5">
      <div class="answer">
        <div>
          <span>你的答案：</span>
          <span class="user-answer" v-if="item.questionType == 0">{{ item.userAnswer ? item.userAnswer : "" }}</span>
          <span class="user-answer" v-else-if="item.questionType == 2 && ['A', 'a'].includes(item.userAnswer)">对</span>
          <span class="user-answer" v-else-if="item.questionType == 2 && ['B', 'b'].includes(item.userAnswer)">错</span>
          <span class="user-answer" v-else>{{ item.userAnswer ? item.userAnswer.toString() : "" }}</span>
        </div>
        <div>
          <span>参考答案：</span>
          <span class="question-answer" v-if="item.questionType == 0">{{ item.questionAnswer ? item.questionAnswer : "" }}</span>
          <span class="question-answer" v-else-if="item.questionType == 2 && ['A', 'a'].includes(item.questionAnswer)">对</span>
          <span class="question-answer" v-else-if="item.questionType == 2 && ['B', 'b'].includes(item.questionAnswer)">错</span>
          <span class="question-answer" v-else>{{ item.questionAnswer ? item.questionAnswer.toString() : "" }}</span>
        </div>
      </div>
      <div class="con">
        <div class="tag">参考解析：</div>
        <div v-html="item.questionAnswerAnalysis"></div>
      </div>
    </div>
 
  </div>
</template>

<script> 
import { queType } from '@/api/emun'

export default {
  name: 'QuestionView',
  // 移除自引用组件注册，避免循环引用问题
  components: {
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        userAnswer: "",
        questionOptionList: [],
      }),
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 1,
    },
    knowledgeClassType: {
      type: String,
      default: "3",
    },
  },
  data() {
    return {
      QuestionEnum: queType,
      knowledgeRef: null
    };
  },
  watch: {
    isSubmit: {
      handler(value) {
        value && this.getKnowledgeList();
      },
      immediate: true
    }
  },
  methods: {
    getKnowledgeList() {
      this.$nextTick(() => {
        this.knowledgeRef && this.knowledgeRef.getKnowledgeList(this.item.questionId);
      });
    },
    playVideo(value) {
      this.$emit("playVideo", value);
    }
  }
};
</script>

<style lang="less" scoped>
.el-radio {
  width: 90px;
  height: 36px;
  margin-right: 10px;
}

.el-checkbox {
  width: 90px;
  height: 36px;
}

.shiti-item {
  background-color: #fff;
  border: 1px solid #e0e3e9;
  margin-bottom: 10px;

  .analysis-con {
    width: 100%;

    .con {
      padding: 20px 30px;

      .tag {
        color: #999;
        margin-bottom: 10px;
      }
    }

    .answer {
      color: #999;
      padding: 0 30px;
      height: 86px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #f9f9f9;
      border-top: 1px dashed #eeeeee;
      border-bottom: 1px dashed #eeeeee;

      .user-answer {
        color: red;
      }

      .question-answer {
        color: #000;
      }
    }
  }

  .el-upload__input {
    display: none;
  }

  .shiti-header {
    cursor: default;
    line-height: 66px;
    overflow: hidden;
    min-height: 66px;
    padding: 0 15px;
    background-color: #f9f9f9;

    img,
    audio,
    video {
      width: 100%;
    }

    .num {
      display: block;
      width: 35px;
      float: left;
      font-size: 24px;
      color: #ee491f;
    }

    .name {
      color: #009aff;
      font-size: 14px;
      float: left;
      margin-right: 10px;
    }

    .tigan {
      display: block;
      overflow: hidden;
      font-size: 16px;
      color: #666;
      min-height: 35px;
      float: left;
      width: 86%;
      margin-left: 10px;
      line-height: 2;
      padding: 16px 0;
    }
  }
  .pannelBody {
    padding: 15px;
    line-height: 1.8;
    font-size: 14px;
  }

  .option-html {
    padding: 15px;
    padding-left: 30px;
    display: flex;
  }

  .option {
    padding: 0 10px;

    .btn {
      min-width: 90px;
      text-align: left;
      margin-right: 10px;
    }

    .btn-default {
      color: #333;
      background-color: #fff;
      border-color: #ccc;
    }
  }

  .upload {
    margin-top: 10px;
  }

  .shiti-tiankong {
    width: 100%;
    padding: 15px;

    textarea {
      resize: none;
      width: 100%;
      height: 100px;
      border: 1px solid #e0e3e9;
      padding: 10px;
      resize: none;
    }
  }

  .shiti-zhuguan {
    width: 100%;
    padding: 15px;

    textarea {
      resize: none;
      width: 100%;
      height: 100px;
      border: 1px solid #e0e3e9;
      padding: 10px;
      resize: none;
    }
  }
}
.shiti-item-2 {
  margin: 10px 20px;
  .shiti-header {
    .num {
      font-size: 18px;
    }
  }
}
</style>
